module.exports = __webpack_public_path__ + "img/givbux.362e61d6.png";